module.exports = __webpack_public_path__ + "img/va-vr.7af96669.svg";